import { render, staticRenderFns } from "./ConfigWebsiteCatalogueUpdate.vue?vue&type=template&id=d9a276de&scoped=true"
import script from "./ConfigWebsiteCatalogueUpdate.vue?vue&type=script&lang=js"
export * from "./ConfigWebsiteCatalogueUpdate.vue?vue&type=script&lang=js"
import style0 from "./ConfigWebsiteCatalogueUpdate.vue?vue&type=style&index=0&id=d9a276de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9a276de",
  null
  
)

export default component.exports